import React from "react";
import { useNavigate } from "react-router-dom";
function CompanyLogo({ title, way, subtitle }) {
  const capitalizeWords = (string) => {
    if (!string) return string;
    return string
      ?.split(" ")?.map((word) => word.charAt(0).toUpperCase() + word?.slice(1))?.join(" "); 
  };
  const navigate = useNavigate();
  return (
    <div onClick={() => navigate(`/`)}>
      {/* <div className="bg-subheader_background w-full h-32 flex flex-col items-center justify-center cursor-pointer">
        <p className="text-xl md:text-2xl font-semibold text-text_color">
          {title}
        </p>
        <div className="2xl:flex xl:flex lg:flex md:flex block justify-center text-center text-sm font-normal space-x-1">
          <span>Home {way && `/`}</span> <span>{capitalizeWords(way)}</span>
          {subtitle && (
            <p className="text-sm font-normal text-primaryColor">
              / {subtitle}
            </p>
          )}
        </div>
      </div> */}
    </div>
  );
}

export default CompanyLogo;
